import idb from "@/plugins/indexdb.js";
import UsersRepository from "../../repositories/usersRepository";

export default {
  namespaced: true,
  state: {
    users: []
  },
  mutations: {
    // Set users
    setUsers(state, users) {
      state.users = users;
    }
  },
  actions: {
    // Get all users from api
    async getUsers({ commit, state }) {
      try {
        const { data } = await UsersRepository.get();
        commit("setUsers", data);

        // Save users in IndexedDB
        await idb.db.users.bulkPut(state.users);
      } catch (error) {
        console.log(error);
      }
    },

    // Get all users from IndexedDB
    getLocalUsers() {
      return new Promise((resolve, reject) => {
        idb.db.users
          .toArray()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // Clean store
    async clean({ commit }) {
      commit("setUsers", []);
      return;
    }
  }
};
